import { ReplaySubject } from 'rxjs';

type ValuesOf<T> = T[keyof T];

export type ABTestTaskListType = keyof typeof abTestList;
export type HeaderMainGroupType = ValuesOf<{
  [K in keyof typeof abTestList]: (typeof abTestList)[K]['headerMainGroup'];
}>;
export type ABVariantsType = ValuesOf<{
  [K in keyof typeof abTestList]: ValuesOf<(typeof abTestList)[K]['abTestGroupIds']>;
}>;

export interface ABTestItem<K extends keyof typeof abTestList> {
  nameOfTask?: ABTestTaskListType;
  alias?: string;
  headerMainGroup: HeaderMainGroupType;
  abTestVariants: ABVariantsType[];
  abTestGroupIds: Record<keyof (typeof abTestList)[K]['abTestGroupIds'], ABVariantsType>;
  resolvedValue?: ABVariantsType;
  resolvedValue$?: ReplaySubject<ABVariantsType>;
  resolvedCookieValue?: ABVariantsType;
  syncOnAuth?: boolean;
  debug?: boolean;
}

export const AB_TEST_LIST: {
  [K in keyof typeof abTestList]: ABTestItem<K>;
} = {} as any;

export const abTestList = {
  DEVSS8543: {
    alias: 'DEVSS8543',
    headerMainGroup: 'ID1398',
    abTestGroupIds: {
      V1: 'ID1398',
      V2: 'ID1399',
    },
    syncOnAuth: true,
    debug: false,
  },
  DEVSS7026: {
    alias: 'DEVSS7026',
    headerMainGroup: 'ID1107',
    abTestGroupIds: {
      V1: 'ID1107',
      V2: 'ID1108',
    },
    syncOnAuth: true,
    debug: false,
  },
  DEVSS7790: {
    alias: 'DEVSS7790',
    headerMainGroup: 'ID1230',
    abTestGroupIds: {
      V1: 'ID1230',
      V2: 'ID1231',
    },
    syncOnAuth: true,
    debug: false,
  },
} as const;
